var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emptyBox",class:_vm.className,style:({
    top: _vm.top + 'px',
    bottom: _vm.bottom + 'px',
    left: _vm.left + 'px',
    right: _vm.right + 'px'
  })},[_c('div',{staticClass:"con"},[_c('div',{staticClass:"img"}),_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }